import type API from "@/Api/API";
import type { AclResource } from "@/types/acl";

export default class Acl {
	api: API;

	constructor(api: API) {
		this.api = api;
	}

	async getResourceAccess(
		resourceType: AclResource,
		resourceId: number
	): Promise<string[]> {
		return this.api
			.processRequest("GET", `/acl/${resourceType}/${resourceId}`)
			.then((res) => res.data);
	}

	async grantResourceAccess(
		userUuid: string,
		resourceType: AclResource,
		resourceId: number
	): Promise<void> {
		await this.api.processRequest(
			"PUT",
			`/acl/${userUuid}/${resourceType}/${resourceId}/grant`
		);
	}

	async revokeResourceAccess(
		userUuid: string,
		resourceType: AclResource,
		resourceId: number
	): Promise<void> {
		await this.api.processRequest(
			"PUT",
			`/acl/${userUuid}/${resourceType}/${resourceId}/revoke`
		);
	}
}
